import { useQuery } from '@tanstack/react-query';
import { Md5 } from 'ts-md5';

import { GRAVATAR_API_URL } from '@/config';
import { publicClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { gravatarQueryKeys } from './query-keys';

export interface GetGravatarParams {
  email: string;
}

export function getGravatarURL({ email }: GetGravatarParams): Promise<string> {
  const address = String(email).trim().toLowerCase();
  const hash = Md5.hashStr(address);
  const gravatarClient = publicClient(GRAVATAR_API_URL);

  return gravatarClient.get(`/${hash}?d=404`).then(() => `${gravatarClient.getUri()}/${hash}`);
}
type QueryFnType = typeof getGravatarURL;

interface GravatarParams {
  email: string | null | undefined;
  config?: QueryConfig<QueryFnType>;
}

export function useGravatarURL({ email, config = {} }: GravatarParams) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    enabled: !!email,
    queryKey: gravatarQueryKeys.url,
    queryFn() {
      if (!email) {
        throw new Error('Email is required');
      }
      return getGravatarURL({ email });
    },
  });
}
